import React from 'react';
import CreatePasswordFunctional from './components/create-password-functional';
import './create-password.scss';

const CreatePassword = () => {
	return <CreatePasswordFunctional />;
};

export default CreatePassword;
